import axios from "axios";
import { msalInstance, initiateLogin } from "@/plugins/msal.js";
import { b2cPolicies } from "@/b2cPolicies";
import store from "@/store";

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          const silentRequest = {
            account: accounts[0],
            scopes: b2cPolicies.scopes,
          };

          const response = await msalInstance.acquireTokenSilent(silentRequest);
          store.dispatch("auth/setAuthentication", {
            userId: response.account.idTokenClaims.extension_efundid,
            accessToken: response.accessToken,
          });

          originalRequest.headers.Authorization = `Bearer ${response.accessToken}`;
          return axios(originalRequest);
        } else {
          initiateLogin();
        }
      } catch (error) {
        console.error("Token refresh failed:", error);
        initiateLogin();
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
